import { render, staticRenderFns } from "./RemoveResourceModal.vue?vue&type=template&id=7f26976b&scoped=true&lang=pug"
import script from "./RemoveResourceModal.vue?vue&type=script&lang=js"
export * from "./RemoveResourceModal.vue?vue&type=script&lang=js"
import style0 from "./RemoveResourceModal.vue?vue&type=style&index=0&id=7f26976b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f26976b",
  null
  
)

export default component.exports